export const IDLE_TIMEOUT_MINUTES = 60
export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000

export const TOKEN_REFRESH_MINUTES = 5
export const TOKEN_REFRESH_MS = TOKEN_REFRESH_MINUTES * 60 * 1000



// WEBPACK FOOTER //
// ./src/config/session.js